import { IConstructionType, IConstructionTypeTypes } from "../types";

export const generateConstructionTypeName = (type: string): string => {
  const translationMap: Record<IConstructionType, string> = {
    [IConstructionTypeTypes.CONSTRUCTION]: "Строительство",
    [IConstructionTypeTypes.RECONSTRUCTION]: "Реконструкция",
    [IConstructionTypeTypes.RENOVATION]: "Реновация",
  };

  if (type in translationMap) {
    return translationMap[type as IConstructionType];
  }

  return "-";
};
